import { extendModeOptions, extendTargetOptions } from './constants'

export const getTargetOptions = t =>
  extendTargetOptions.map(option => ({
    ...option,
    label: t(option.label),
  }))

export const getModeOptions = t =>
  extendModeOptions.map(option => ({
    ...option,
    label: t(option.label),
  }))
